// Facets JavaScript - Custom filter handling with Price slider and Discount

// Initialize facets tabs
function initFacetsTabs() {
  const tabLabels = document.querySelectorAll('.sm-facets-tabs__label-item');
  const tabPanels = document.querySelectorAll('.sm-facets-tabs__panel');

  if (tabLabels.length === 0) return;

  // Sync the visible panel with the active label. The active label may
  // already be server-rendered (Liquid), so "has active label" alone is
  // not enough — the matching panel must be activated too.
  const activeLabel = document.querySelector('.sm-facets-tabs__label-item.active') || tabLabels[0];
  const activeTabId = activeLabel.getAttribute('data-tab');
  tabLabels.forEach(l => l.classList.remove('active'));
  activeLabel.classList.add('active');
  tabPanels.forEach(panel => panel.classList.remove('active'));
  const activePanel = document.querySelector(`[data-panel="${activeTabId}"]`);
  if (activePanel) activePanel.classList.add('active');

  tabLabels.forEach(label => {
    if (label.dataset.tabBound === 'true') return;
    label.dataset.tabBound = 'true';
    label.addEventListener('click', () => {
      const tabId = label.getAttribute('data-tab');

      // Update active tab label
      tabLabels.forEach(l => l.classList.remove('active'));
      label.classList.add('active');

      // Update active tab panel
      tabPanels.forEach(panel => panel.classList.remove('active'));
      const targetPanel = document.querySelector(`[data-panel="${tabId}"]`);
      if (targetPanel) targetPanel.classList.add('active');
    });
  });
}

// Price range slider initialization
function initPriceRangeSliders() {
  const rangeMin = document.getElementById('price-range-min');
  const realRangeMax = document.getElementById('price-range-max');
  const inputMin = document.getElementById('price-min');
  const inputMax = document.getElementById('price-max');
  const progress = document.querySelector('[data-price-progress]');
  const bubbleMinText = document.querySelector('[data-price-bubble-min-text]');
  const bubbleMaxText = document.querySelector('[data-price-bubble-max-text]');
  const thumbMin = document.querySelector('[data-thumb-min]');
  const thumbMax = document.querySelector('[data-thumb-max]');
  const sliderContainerEl = document.querySelector('.sm-price-range__slider-container');

  if (!realRangeMax) return;
  // Use realRangeMax as the actual range element
  const rangeMaxEl = realRangeMax;

  // Format a price for the value tags that follow the handles ($X.XX).
  function formatBubblePrice(value) {
    const num = parseFloat(value);
    if (isNaN(num)) return '$0.00';
    const currencyEl = document.querySelector('.sm-price-range__currency');
    const symbol = currencyEl && currencyEl.textContent.trim() ? currencyEl.textContent.trim() : '$';
    return symbol + num.toFixed(2);
  }

  // Helper function to extract numeric price from formatted string
  function extractPriceFromText(text) {
    if (!text) return 0;
    const match = text.toString().replace(/[^0-9.]/g, '');
    const price = parseFloat(match);
    return isNaN(price) ? 0 : price;
  }

  // Price bounds come from Shopify's price_range filter, server-rendered as
  // data attributes on the slider container — this always matches the
  // collection's real price range. DOM scraping is only a fallback.
  const sliderContainer = document.querySelector('.sm-price-range');
  let minPrice = sliderContainer ? parseFloat(sliderContainer.dataset.priceMin) : NaN;
  let maxPrice = sliderContainer ? parseFloat(sliderContainer.dataset.priceMax) : NaN;

  if (!(maxPrice > 0)) {
    // Fallback: detect prices from product cards INSIDE the collection grid
    // only (never other sections like carousels / recently-viewed).
    const scope = document.querySelector('wws-collection-grid') || document;
    const priceSelectors = [
      '[data-product-price]',
      '.wws-product-card__price > span:not(.wws-product-card__compare-price):not(.wws-product-card__savings):not(.wws-product-card__price-prefix)',
      '.sm-price .price-item:last-child',
      '.sm-price:not(.price--sold-out) .price-item--regular',
      '.sm-product-card .sm-price .price',
      '.sm-product-card .price .amount',
      '.price__current .money',
      '.sm-price__current'
    ];

    let prices = [];

    for (const selector of priceSelectors) {
      const priceElements = scope.querySelectorAll(selector);
      if (priceElements.length > 0) {
        prices = Array.from(priceElements)
          .map(el => extractPriceFromText(el.dataset && el.dataset.productPrice ? el.dataset.productPrice : el.textContent || ''))
          .filter(p => p > 0);
        if (prices.length > 0) break;
      }
    }

    if (prices.length > 0) {
      minPrice = Math.min(...prices);
      maxPrice = Math.max(...prices);
    }
  }

  // Final fallbacks
  if (!(maxPrice > 0)) maxPrice = 200;
  if (!(minPrice >= 0)) minPrice = 0;

  // Helper: format number for input fields (always 2 decimals)
  function formatInputValue(value) {
    const num = parseFloat(value);
    if (isNaN(num)) return '0.00';
    return num.toFixed(2);
  }

  // Respect server-rendered current values (an already-applied price filter);
  // otherwise start at the full range.
  let startMin = minPrice;
  let startMax = maxPrice;
  if (inputMin && inputMin.value.trim() !== '') {
    const v = parseFloat(inputMin.value);
    if (!isNaN(v)) startMin = v;
  }
  if (inputMax && inputMax.value.trim() !== '') {
    const v = parseFloat(inputMax.value);
    if (!isNaN(v)) startMax = v;
  }
  startMin = Math.max(minPrice, Math.min(startMin, maxPrice));
  startMax = Math.max(minPrice, Math.min(startMax, maxPrice));
  if (startMin > startMax) {
    const swap = startMin;
    startMin = startMax;
    startMax = swap;
  }

  // Set initial values on ranges
  rangeMin.min = minPrice;
  rangeMin.max = maxPrice;
  rangeMin.value = startMin;
  rangeMin.setAttribute('aria-valuenow', startMin);
  rangeMin.setAttribute('aria-valuemin', minPrice);
  rangeMin.setAttribute('aria-valuemax', maxPrice);

  rangeMaxEl.min = minPrice;
  rangeMaxEl.max = maxPrice;
  rangeMaxEl.value = startMax;
  rangeMaxEl.setAttribute('aria-valuenow', startMax);
  rangeMaxEl.setAttribute('aria-valuemin', minPrice);
  rangeMaxEl.setAttribute('aria-valuemax', maxPrice);

  // Set initial input values - use both value and setAttribute to ensure sync
  if (inputMin) {
    inputMin.value = formatInputValue(startMin);
    inputMin.setAttribute('value', formatInputValue(startMin));
    inputMin.placeholder = formatInputValue(minPrice);
  }
  if (inputMax) {
    inputMax.value = formatInputValue(startMax);
    inputMax.setAttribute('value', formatInputValue(startMax));
    inputMax.placeholder = formatInputValue(maxPrice);
  }

  // Update progress bar
  updateProgress();

  // Re-calculate after a short delay to ensure container is rendered
  setTimeout(updateProgress, 50);

  // Write initial min/max into the two end-of-track bubbles so the
  // values are visible at the left/right of the slider right away.
  if (bubbleMinText) bubbleMinText.textContent = formatBubblePrice(startMin);
  if (bubbleMaxText) bubbleMaxText.textContent = formatBubblePrice(startMax);

  // Suppress native browser tooltips so they never overlap our fixed
  // end-of-track bubbles. The HTML already has tabindex/onfocus guards,
  // but Edge/Chrome can still trigger the tooltip on click+drag, so we
  // belt-and-suspenders it with JS event listeners.
  [rangeMin, rangeMaxEl].forEach(input => {
    input.addEventListener('focus', () => input.blur());
    input.addEventListener('pointerdown', () => {
      // Let the click register, then drop focus immediately so the
      // browser's built-in value tooltip has nothing to anchor to.
      requestAnimationFrame(() => input.blur());
    });
  });

  rangeMin.addEventListener('input', () => {
    let val = parseFloat(rangeMin.value);
    let maxVal = parseFloat(rangeMaxEl.value);
    // Clamp to lower bound
    if (val < minPrice) {
      val = minPrice;
      rangeMin.value = val;
    }
    // Don't cross over max
    if (val > maxVal - 1) {
      val = Math.max(minPrice, maxVal - 1);
      rangeMin.value = val;
    }
    // Sync to input (unless user is currently typing in it)
    if (inputMin && document.activeElement !== inputMin) {
      inputMin.value = parseFloat(val).toFixed(2);
    }
    // Fixed left label shows the current min value
    if (bubbleMinText) bubbleMinText.textContent = formatBubblePrice(val);
    updateProgress();
  });

  rangeMaxEl.addEventListener('input', () => {
    let val = parseFloat(rangeMaxEl.value);
    let minVal = parseFloat(rangeMin.value);
    // Clamp to upper bound
    if (val > maxPrice) {
      val = maxPrice;
      rangeMaxEl.value = val;
    }
    // Don't cross over min
    if (val < minVal + 1) {
      val = minVal + 1;
      rangeMaxEl.value = val;
    }
    // Sync to input (unless user is currently typing in it)
    if (inputMax && document.activeElement !== inputMax) {
      inputMax.value = parseFloat(val).toFixed(2);
    }
    // Fixed right label shows the current max value
    if (bubbleMaxText) bubbleMaxText.textContent = formatBubblePrice(val);
    updateProgress();
  });

  // Number input events - sync FROM input TO range
  if (inputMin) {
    inputMin.addEventListener('input', () => {
      const raw = inputMin.value.trim();
      if (raw === '') return; // Don't update range while clearing
      let val = parseFloat(raw);
      if (isNaN(val)) return;
      const maxVal = parseFloat(rangeMaxEl.value);
      // Apply bounds
      if (val < minPrice) val = minPrice;
      if (val > maxVal - 1) val = maxVal - 1;
      rangeMin.value = val;
      if (bubbleMinText) bubbleMinText.textContent = formatBubblePrice(val);
      updateProgress();
    });
    // On blur, format cleanly
    inputMin.addEventListener('blur', () => {
      const val = parseFloat(inputMin.value);
      if (!isNaN(val)) {
        inputMin.value = val.toFixed(2);
      } else {
        inputMin.value = formatInputValue(minPrice);
      }
    });
  }

  if (inputMax) {
    inputMax.addEventListener('input', () => {
      const raw = inputMax.value.trim();
      if (raw === '') return;
      let val = parseFloat(raw);
      if (isNaN(val)) return;
      const minVal = parseFloat(rangeMin.value);
      // Apply bounds
      if (val > maxPrice) val = maxPrice;
      if (val < minVal + 1) val = minVal + 1;
      rangeMaxEl.value = val;
      if (bubbleMaxText) bubbleMaxText.textContent = formatBubblePrice(val);
      updateProgress();
    });
    inputMax.addEventListener('blur', () => {
      const val = parseFloat(inputMax.value);
      if (!isNaN(val)) {
        inputMax.value = val.toFixed(2);
      } else {
        inputMax.value = formatInputValue(maxPrice);
      }
    });
  }

  function updateProgress() {
    const min = parseFloat(rangeMin.value);
    const max = parseFloat(rangeMaxEl.value);
    const range = maxPrice - minPrice || 1;
    const leftPercent = ((min - minPrice) / range) * 100;
    const rightPercent = ((max - minPrice) / range) * 100;

    if (progress) {
      progress.style.left = leftPercent + '%';
      progress.style.right = (100 - rightPercent) + '%';
    }

    // Keep the visible drag thumbs on top of their track positions
    positionThumbs();
  }

  // Move the visible thumb handles to match the current slider values.
  // Thumbs are centered on their left position via the CSS margin-left.
  // The static end-of-track price labels are fixed in CSS (left/right ends,
  // in the band above the handles) and are intentionally NOT moved here.
  function positionThumbs() {
    if (!thumbMin || !thumbMax) return;
    const spread = maxPrice - minPrice || 1;
    const minValue = parseFloat(rangeMin.value);
    const maxValue = parseFloat(rangeMaxEl.value);
    const minPct = ((minValue - minPrice) / spread) * 100;
    const maxPct = ((maxValue - minPrice) / spread) * 100;

    // Always use percentage positioning: while the drawer is hidden the
    // container width is 0, but a percentage resolves against the real width
    // automatically once it becomes visible — so both handles appear in the
    // right spots on first open (no re-run needed).
    thumbMin.style.left = minPct + '%';
    thumbMax.style.left = maxPct + '%';
  }

  // Make a thumb handle draggable with Pointer Events. Dragging writes the
  // (hidden) shared range input and dispatches 'input', so the existing range
  // listeners above keep the number inputs, progress bar and thumb positions
  // in sync — i.e. the values in the boxes on top change while sliding.
  function makeThumbDraggable(thumb, isMinHandle) {
    if (!thumb || thumb.dataset.dragBound === 'true') return;
    thumb.dataset.dragBound = 'true';

    let dragging = false;
    let dragOffsetRatio = 0;

    thumb.addEventListener('pointerdown', (event) => {
      event.preventDefault();
      if (!sliderContainerEl) return;
      const rect = sliderContainerEl.getBoundingClientRect();
      const target = isMinHandle ? rangeMin : rangeMaxEl;
      const currentRatio = rect.width > 0
        ? (parseFloat(target.value) - minPrice) / (maxPrice - minPrice || 1)
        : 0;
      dragOffsetRatio = rect.width > 0
        ? ((event.clientX - rect.left) / rect.width) - currentRatio
        : 0;
      dragging = true;
      thumb.classList.add('is-dragging');
      thumb.setPointerCapture(event.pointerId);
    });

    thumb.addEventListener('pointermove', (event) => {
      if (!dragging || !sliderContainerEl) return;
      const rect = sliderContainerEl.getBoundingClientRect();
      if (rect.width <= 0) return;
      let ratio = ((event.clientX - rect.left) / rect.width) - dragOffsetRatio;
      ratio = Math.max(0, Math.min(1, ratio));
      const spread = maxPrice - minPrice;
      let value = Math.round(minPrice + ratio * spread);

      if (isMinHandle) {
        value = Math.max(minPrice, Math.min(value, parseFloat(rangeMaxEl.value) - 1));
      } else {
        value = Math.min(maxPrice, Math.max(value, parseFloat(rangeMin.value) + 1));
      }

      const target = isMinHandle ? rangeMin : rangeMaxEl;
      target.value = value;
      target.dispatchEvent(new Event('input', { bubbles: true }));
    });

    const endDrag = (event) => {
      if (!dragging) return;
      dragging = false;
      thumb.classList.remove('is-dragging');
      if (thumb.hasPointerCapture && thumb.hasPointerCapture(event.pointerId)) {
        thumb.releasePointerCapture(event.pointerId);
      }
    };

    thumb.addEventListener('pointerup', endDrag);
    thumb.addEventListener('pointercancel', endDrag);
    thumb.addEventListener('lostpointercapture', () => {
      dragging = false;
      thumb.classList.remove('is-dragging');
    });
  }

  makeThumbDraggable(thumbMin, true);
  makeThumbDraggable(thumbMax, false);

  // Keep the latest updater so a single resize listener re-positions thumbs
  // after the drawer/viewport changes size (multiple inits re-run safely).
  initPriceRangeSliders._latestUpdateProgress = updateProgress;
  if (!initPriceRangeSliders._resizeBound) {
    initPriceRangeSliders._resizeBound = true;
    window.addEventListener('resize', () => {
      if (typeof initPriceRangeSliders._latestUpdateProgress === 'function') {
        initPriceRangeSliders._latestUpdateProgress();
      }
    });
  }

  // If this ran while the drawer was hidden, retry a couple of times so the
  // value tags get measured and revealed once the drawer lays out.
  if (!sliderContainerEl || !sliderContainerEl.clientWidth) {
    setTimeout(updateProgress, 150);
    setTimeout(updateProgress, 600);
  }

  // Some drawer implementations don't re-fire init on open (the open state may
  // not be reflected as an attribute), so watch the drawer element itself and
  // reposition/reveal the tags as soon as it becomes visible.
  const drawerEl = document.getElementById('facets-drawer');
  if (drawerEl && !drawerEl.dataset.priceRangeWatch) {
    drawerEl.dataset.priceRangeWatch = 'true';
    const reposition = () => requestAnimationFrame(() => updateProgress());
    const debouncedReposition = () => {
      clearTimeout(debouncedReposition._t);
      debouncedReposition._t = setTimeout(reposition, 60);
    };
    new MutationObserver(debouncedReposition).observe(drawerEl, {
      attributes: true,
      attributeFilter: ['open', 'class', 'style']
    });
  }
}

// FacetFiltersForm - Main form handling
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form[data-filter-form]');
    this.sectionId = this.dataset.sectionId;
    this.debounceTimer = null;

    // The nested <form> inside the WWS <form data-filter-form> is dropped by
    // browsers (form-in-form is invalid HTML), so this.form may not exist.
    // Filtering is driven by the Apply button (FacetApply) in that case.
    if (!this.form) return;

    // Bind events
    this.addEventListener('onActiveFilterClick', this.onActiveFilterClick.bind(this));

    // Listen for checkbox changes only — price/number inputs are handled by Apply button
    this.form.addEventListener('change', (event) => {
      if (event.target.type === 'checkbox' || event.target.type === 'radio') {
        this.onFormChange(event);
      }
    });
  }

  onActiveFilterClick(event) {
    const removeLink = event.target.closest('[data-filter-remove]');
    if (removeLink) {
      event.preventDefault();
      this.removeFilter(removeLink.href);
    }
  }

  onFormChange(event) {
    // Debounce the filter change
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.applyFilters();
    }, 300);
  }

  applyFilters() {
    // Collect all active filters
    const params = new URLSearchParams();

    // Get Shopify filters from hidden inputs
    const shopifyInputs = this.form.querySelectorAll('.shopify-filter-input');
    shopifyInputs.forEach(input => {
      if (input.type === 'checkbox' && input.checked) {
        params.append(input.name, input.value);
      } else if (input.type !== 'checkbox' && input.value) {
        params.append(input.name, input.value);
      }
    });

    // Get price range — skip full-range defaults (same rule as FacetApply)
    const priceMin = document.getElementById('price-min');
    const priceMax = document.getElementById('price-max');
    const sliderContainer = document.querySelector('.sm-price-range');
    const boundMin = sliderContainer ? parseFloat(sliderContainer.dataset.priceMin) : NaN;
    const boundMax = sliderContainer ? parseFloat(sliderContainer.dataset.priceMax) : NaN;
    const priceAlreadyActive = sliderContainer && sliderContainer.dataset.priceActive === 'true';
    if (priceMin && priceMin.value) {
      const v = parseFloat(priceMin.value);
      if (priceAlreadyActive || isNaN(boundMin) || isNaN(v) || v > boundMin) {
        params.append('filter.v.price.gte', priceMin.value);
      }
    }
    if (priceMax && priceMax.value) {
      const v = parseFloat(priceMax.value);
      if (priceAlreadyActive || isNaN(boundMax) || isNaN(v) || v < boundMax) {
        params.append('filter.v.price.lte', priceMax.value);
      }
    }

    // Get discount filters (handled by frontend)
    const discountFilters = this.form.querySelectorAll('[data-filter-type="discount"]:checked');
    if (discountFilters.length > 0) {
      const discountValues = Array.from(discountFilters).map(f => f.value);
      params.set('discount_filters', discountValues.join(','));
    }

    // Collection filters — handled by direct navigation (see collection checkbox → Apply redirect)

    // Get availability filters
    const availabilityFilters = this.form.querySelectorAll('[data-filter-type="availability"]:checked');
    if (availabilityFilters.length > 0) {
      const availabilityValues = Array.from(availabilityFilters).map(f => f.value);
      params.set('availability_filters', availabilityValues.join(','));
    }

    // Trigger filter update
    this.dispatchEvent(new CustomEvent('facets:update', {
      bubbles: true,
      detail: { url: window.location.pathname + '?' + params.toString(), params: params }
    }));
  }
}
customElements.define('facet-filters-form', FacetFiltersForm);

// FacetRemove - Handle filter removal
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const link = this.querySelector('a');
    if (link) {
      link.addEventListener('click', (event) => {
        this.onRemoveLinkClick(event);
      });
    }
  }

  onRemoveLinkClick(event) {
    event.preventDefault();

    // Prefer the WWS grid's AJAX path so Remove All feels like Apply:
    // close the drawer, show the grid loading overlay, update in place.
    const grid = document.querySelector('wws-collection-grid');
    const wwsForm = grid ? grid.querySelector('[data-filter-form]') : null;
    if (grid && wwsForm && typeof grid.submitFilters === 'function') {
      // Clear every filter input so the submitted FormData carries none.
      wwsForm.querySelectorAll('[data-custom-facet-input]').forEach(el => el.remove());
      wwsForm.querySelectorAll('input[name^="filter."], select[name^="filter."], textarea[name^="filter."]').forEach(input => {
        input.disabled = true;
      });
      const drawer = this.closest('sliding-drawer');
      if (drawer) drawer.close();
      grid.submitFilters();
      return;
    }

    // No code listens for a 'facet:remove' event — navigate directly to the
    // unfiltered URL carried by the link instead.
    window.location.href = event.currentTarget.href;
  }
}
customElements.define("facet-remove", FacetRemove);

// FacetApply - Handle apply button
class FacetApply extends HTMLElement {
  constructor() {
    super();
    const facetButton = this.querySelector("button");
    facetButton.addEventListener("click", this.applyFilter.bind(this));

    // Keyboard accessibility
    facetButton.addEventListener("keydown", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE")
        this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }

  applyFilter(event) {
    event.preventDefault();
    event.stopPropagation();

    // Check if a different collection (not the current page's) is selected
    const selectedCollection = document.querySelector('[data-filter-type="collection"]:checked');
    if (selectedCollection) {
      const collectionUrl = selectedCollection.dataset.collectionUrl;
      const currentUrl = window.location.pathname;
      // Only redirect if selecting a different collection
      if (collectionUrl && new URL(collectionUrl, window.location.origin).pathname !== currentUrl) {
        // Close drawer and navigate to the collection page
        const drawer = this.closest("sliding-drawer");
        if (drawer) drawer.close();
        window.location.href = collectionUrl;
        return;
      }
    }

    // Get the WWS collection grid form (the main form that controls filtering)
    const wwsCollectionGrid = document.querySelector("wws-collection-grid");
    const wwsForm = wwsCollectionGrid ? wwsCollectionGrid.querySelector('[data-filter-form]') : null;

    // Collect all filter values from the drawer
    const filters = this.collectFilters();

    // Sync drawer filters into WWS collection form
    if (wwsForm) {
      // Remove existing custom filter inputs we may have added before
      wwsForm.querySelectorAll('[data-custom-facet-input]').forEach(el => el.remove());

      // Helper to add hidden input to WWS form
      const addInput = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        input.dataset.customFacetInput = 'true';
        wwsForm.appendChild(input);
      };

      // Sync price range
      if (filters.price.min !== null) {
        addInput('filter.v.price.gte', filters.price.min);
      }
      if (filters.price.max !== null) {
        addInput('filter.v.price.lte', filters.price.max);
      }

      // Sync custom filters
      if (filters.discount.length > 0) {
        addInput('discount_filters', filters.discount.join(','));
      }
      // Collection handled by direct navigation (see applyFilter)
      if (filters.availability.length > 0) {
        addInput('availability_filters', filters.availability.join(','));
      }

      // Deselect fix: the WWS form also contains hidden server-state mirror
      // checkboxes ([data-param-name]) for currently-active filters. They stay
      // checked even after the user unchecks the visible drawer option, so the
      // stale value would be submitted again. Disable any mirror that has a
      // visible drawer counterpart — the visible checkbox's state then wins.
      const cssEscape = window.CSS && CSS.escape ? CSS.escape : (str) => String(str).replace(/["\\]/g, '\\$&');
      wwsForm.querySelectorAll('.shopify-filter-input[data-param-name]').forEach(mirror => {
        // Price mirrors: the drawer price inputs are authoritative. A custom
        // hidden input is added above whenever a price value should be sent,
        // so the mirror must never submit too — otherwise the stale server
        // value duplicates/overrides the new one. Disabling also lets the
        // user CLEAR an active price filter (empty inputs → no param at all).
        if (mirror.name === 'filter.v.price.gte' || mirror.name === 'filter.v.price.lte') {
          mirror.disabled = true;
          return;
        }
        const visible = document.querySelector(
          `.facet-filter-checkbox[name="${cssEscape(mirror.name)}"][value="${cssEscape(mirror.value)}"]`
        );
        if (visible) mirror.disabled = true;
      });

      // If we have a WWS collection grid with submitFilters, use it
      if (wwsCollectionGrid && typeof wwsCollectionGrid.submitFilters === 'function') {
        console.log('[FacetApply] Submitting via WWSCollectionGrid.submitFilters()', filters);

        // Close drawer first
        const drawer = this.closest("sliding-drawer");
        if (drawer) drawer.close();

        wwsCollectionGrid.submitFilters();
        return;
      }
    }

    // Fallback: standard form submission via URL redirect
    const params = new URLSearchParams();

    // Shopify filters (from drawer form's hidden inputs)
    const drawerForm = this.closest("facet-filters-form");
    if (drawerForm) {
      const shopifyInputs = drawerForm.querySelectorAll('.shopify-filter-input');
      shopifyInputs.forEach(input => {
        if (input.disabled) return;
        if (input.type === 'checkbox' && input.checked) {
          params.append(input.name, input.value);
        }
      });
    }

    // Price range
    if (filters.price.min !== null) {
      params.append('filter.v.price.gte', filters.price.min);
    }
    if (filters.price.max !== null) {
      params.append('filter.v.price.lte', filters.price.max);
    }

    // Custom filters
    if (filters.discount.length > 0) {
      params.set('discount_filters', filters.discount.join(','));
    }
    // Collection handled by direct navigation above
    if (filters.availability.length > 0) {
      params.set('availability_filters', filters.availability.join(','));
    }

    // Preserve sort_by
    const url = new URL(window.location.href);
    const sortParam = url.searchParams.get('sort_by');
    if (sortParam) {
      params.set('sort_by', sortParam);
    }

    // Close drawer
    const drawer = this.closest("sliding-drawer");
    if (drawer) drawer.close();

    // Navigate to filtered URL
    window.location.href = window.location.pathname + '?' + params.toString();
  }

  collectFilters() {
    const drawerForm = this.closest("facet-filters-form");
    const form = drawerForm ? drawerForm.querySelector('form[data-filter-form]') : null;
    const filters = {
      shopify: [],
      price: { min: null, max: null },
      discount: [],
      availability: []
    };

    // Shopify filters
    if (form) {
      const shopifyInputs = form.querySelectorAll('.shopify-filter-input');
      shopifyInputs.forEach(input => {
        if (input.type === 'checkbox' && input.checked) {
          filters.shopify.push({ name: input.name, value: input.value });
        }
      });
    }

    // Price range — skip values that are just the full catalog range when no
    // price filter is currently applied, so Apply doesn't add no-op params.
    const priceMin = document.getElementById('price-min');
    const priceMax = document.getElementById('price-max');
    const sliderContainer = document.querySelector('.sm-price-range');
    const boundMin = sliderContainer ? parseFloat(sliderContainer.dataset.priceMin) : NaN;
    const boundMax = sliderContainer ? parseFloat(sliderContainer.dataset.priceMax) : NaN;
    const priceAlreadyActive = sliderContainer && sliderContainer.dataset.priceActive === 'true';
    if (priceMin && priceMin.value) {
      const v = parseFloat(priceMin.value);
      const isDefault = !priceAlreadyActive && !isNaN(boundMin) && !isNaN(v) && v <= boundMin;
      if (!isDefault) filters.price.min = priceMin.value;
    }
    if (priceMax && priceMax.value) {
      const v = parseFloat(priceMax.value);
      const isDefault = !priceAlreadyActive && !isNaN(boundMax) && !isNaN(v) && v >= boundMax;
      if (!isDefault) filters.price.max = priceMax.value;
    }

    // Discount
    document.querySelectorAll('[data-filter-type="discount"]:checked').forEach(f => filters.discount.push(f.value));
    // Collection — handled by direct navigation
    // Availability
    document.querySelectorAll('[data-filter-type="availability"]:checked').forEach(f => filters.availability.push(f.value));

    return filters;
  }
}
customElements.define("facet-apply", FacetApply);

// Listen for filter update events
document.addEventListener('facets:update', (event) => {
  console.log('[Facets] Update filters:', event.detail.url);
});

// Listen for WWS collection grid events
document.addEventListener('wws:collection-updated', () => {
  setTimeout(() => {
    if (typeof initFacetsTabs === 'function') initFacetsTabs();
    if (typeof initPriceRangeSliders === 'function') initPriceRangeSliders();
  }, 300);
});
